import type { SearchableSelectOption } from '../components/ui/SearchableSelect/SearchableSelect';

interface SubCategoriaComGrupo {
    id: string;
    nome: string;
    categoria: { id: string; nome: string };
}

/**
 * Opcoes do campo de categoria do lancamento agrupadas pelo grupo (MAN-130).
 *
 * No plano de contas o "grupo" e a categoria-pai e a "categoria" e a
 * subcategoria. Os grupos seguem a ordem do plano de contas do cliente (a da
 * lista de categorias da API) e, dentro de cada grupo, a ordem em que as
 * subcategorias vieram. Subcategoria de um grupo que nao veio na lista fica no
 * fim, para nunca sumir da escolha.
 */
export function opcoesAgrupadas(
    subCategorias: SubCategoriaComGrupo[],
    categorias: { id: string }[],
    traduzir: (texto: string) => string = (texto) => texto,
): SearchableSelectOption[] {
    const ordem = new Map(categorias.map((c, i) => [c.id, i]));
    const posicao = (sub: SubCategoriaComGrupo) => ordem.get(sub.categoria.id) ?? Number.MAX_SAFE_INTEGER;
    return subCategorias
        .map((sub, i) => ({ sub, i }))
        .sort((a, b) => posicao(a.sub) - posicao(b.sub) || a.i - b.i)
        .map(({ sub }) => ({ value: sub.id, label: traduzir(sub.nome), group: traduzir(sub.categoria.nome) }));
}
